{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Šablony",
    "DESCRIPTION": "Zobrazte šablony zpráv synchronizované z vašich schránek WhatsApp. Šablonu vytvoříte nebo upravíte u svého poskytovatele.",
    "COUNT": "Počet šablon: {n}",
    "LEARN_MORE": "Více o šablonách WhatsApp",
    "SYNC_TEMPLATES": "Synchronizovat šablony",
    "SYNC_SUCCESS": "Synchronizace šablon začala pro všechny schránky WhatsApp. Změny se projeví do několika minut.",
    "PARTIAL_SYNC_ERROR": "Synchronizace šablon začala jen pro některé schránky WhatsApp, ostatní se synchronizovat nepodařilo.",
    "SYNC_ERROR": "Synchronizaci šablon se nepodařilo spustit. Zkuste to znovu.",
    "SEARCH_PLACEHOLDER": "Hledat podle obsahu nebo názvu...",
    "MANAGE_IN_META": "Spravovat v Meta",
    "LOADING": "Načítání šablon WhatsApp...",
    "EMPTY": "Nenašli jsme žádné šablony WhatsApp.",
    "NO_RESULTS": "Filtrům neodpovídá žádná šablona.",
    "FETCH_ERROR": "Šablony WhatsApp se nepodařilo načíst. Zkuste to znovu.",
    "PARTIAL_FETCH_ERROR": "Některé šablony WhatsApp se nepodařilo načíst. Zkuste to znovu.",
    "LAST_SYNC_ATTEMPT": "Poslední pokus o synchronizaci {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Neodesláno ke schválení ve WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Všechny schránky",
      "ALL_LANGUAGES": "Všechny jazyky",
      "ALL_TYPES": "Všechny typy"
    },
    "TYPES": {
      "TEXT": "Text",
      "IMAGE": "Obrázek",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Výzva k akci",
      "COPY_CODE": "Kopírovat kód"
    },
    "PREVIEW": {
      "TITLE": "Náhled šablony",
      "DESCRIPTION": "Náhled, jak šablona vypadá ve WhatsApp.",
      "OPEN": "Náhled {name}",
      "CLOSE": "Zavřít náhled",
      "DETAILS": "Podrobnosti šablony",
      "STATUS": "Stav",
      "TYPE": "Typ obsahu",
      "CATEGORY": "Kategorie",
      "LANGUAGE": "Jazyk",
      "INBOXES": "Schránky"
    }
  }
}
